// extracted by mini-css-extract-plugin
module.exports = {"pieChart":"styles_pieChart__2X_4E"};